import theme from '../../../../shared/theme';

const Styles = {
    Root: {
        backgroundColor: '#343A40',
        '& > .MuiPaper-elevation4': {
            boxShadow: 'none'
        }
    },
    AppBar: {
        position: 'fixed'
    },
    Logo: {
        marginTop: theme.spacing(1.5),
        objectFit: 'contain',
        width: theme.spacing(16),
        height: theme.spacing(8),
        cursor: 'pointer'
    },
    GetStartedButton: {
        marginLeft: theme.spacing(1),
    },
    Accordion: {
        '& < .MuiAccordion-root.Mui-expanded': {
            marginTop: 30,
            marginBottom: 0
        }
    },
    Menu: {
        marginTop: theme.spacing(5),
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#343A40',
    },
    MenuItem: {
        justifyContent: 'center',
        '&:hover': {
            color: 'white'
        }
    },
    MobileToolbar: {
        backgroundColor: '#343A40',
        height: '80px'
    },
    ToolbarContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%'
    },
    FullList: {
        width: 'auto'
    },
    DropdownList: {
        py: 0
    },
    MobileMenuIconContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        position: 'absolute',
        width: '95%'
    },
    MobileMenuContainer: {
        marginTop: '80px'
    },
    MobileMenu: {
        '& .MuiPopover-paper': {
            left: '0px !important'
        }
    },
    MobileMenuItem: {
        backgroundColor: '#c8c8c8',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        cursor: 'pointer',
        opacity: 0.6,
        color: '#000',
        '&:hover': {
            backgroundColor: '#f7f8f9'
        },
        textAlign: 'center',
        '& .MuiTypography-body1': {
            fontSize: '14px'
        }
    },
    SubmenuChild: {
        backgroundColor: '#f1f1f1',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        cursor: 'pointer',
        opacity: 0.6,
        color: '#000',
        '&:hover': {
            backgroundColor: '#f7f8f9'
        },
        textAlign: 'center',
        '& .MuiTypography-body1': {
            fontSize: '14px'
        }
    },
    PopoverPaper: {
        width: '100%',
        maxHeight: 'unset',
        maxWidth: 'calc(100% - 16px)',
        borderRadius: '0px',
    },
    SubmenuItem: {
        marginLeft: '26px'
    }
};

export default Styles;